import React from 'react';
import Loader from 'src/components/Loader/Loader';

export const LoaderWrapper = ({
  isLoading,
  loader,
  children,
}: {
  isLoading: any;
  loader: any;
  children?: any;
}) => {
  return isLoading ? <>{loader || <Loader />}</> : children;
};
